export default "__VITE_ASSET__De0107QM__"